/* eslint-disable @typescript-eslint/no-explicit-any */
import { Observable, Subject } from 'rxjs';

export class DialogRef<T> {
  constructor() {}

  close(result?: T) {
    this._afterClosed.next(result);
  }

  private readonly _afterClosed = new Subject<T | undefined>();
  afterClosed: Observable<T | undefined> = this._afterClosed.asObservable();
}
